import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CloudRain, Droplets, Leaf, Eye } from "lucide-react";

const cards = [
  {
    to: "/innovation",
    icon: CloudRain,
    title: "Our Craft",
    desc: "From the morning sky to your glass — the four careful steps behind the world's purest water.",
  },
  {
    to: "/products",
    icon: Droplets,
    title: "Products",
    desc: "Nyla Alkaline (pH 8.5) and Nyla pH Balanced (7.5) — two waters, one standard of perfection.",
  },
  {
    to: "/sustainability",
    icon: Leaf,
    title: "Sustainability",
    desc: "Zero groundwater taken, zero water wasted, and packaging designed for a second life.",
  },
  {
    to: "/vision",
    icon: Eye,
    title: "Vision",
    desc: "A future where pure water belongs to everyone — without taking a drop from the ground.",
  },
];

export const Explore = () => (
  <section data-testid="explore-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="text-center mb-16 max-w-3xl mx-auto"
      >
        <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">Discover Nyla</p>
        <h2 data-testid="explore-heading" className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-bold text-[#1D1D1F]">
          Explore the world of air water.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
        {cards.map((c, i) => (
          <motion.div
            key={c.to}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.12 }}
          >
            <Link
              to={c.to}
              data-testid={`explore-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex flex-col h-full bg-[#F5F5F7] rounded-3xl p-8 lg:p-12 hover:-translate-y-1 transition-transform duration-300 ease-out"
            >
              <c.icon className="w-8 h-8 text-[#2C3E35] mb-8" strokeWidth={1.5} />
              <h3 className="font-display text-2xl md:text-3xl tracking-tight font-bold text-[#1D1D1F] mb-3">{c.title}</h3>
              <p className="text-base leading-relaxed text-[#86868B] mb-6 flex-1">{c.desc}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[#2C3E35]">
                Learn more
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
